import React, { Component } from "react";
import { asModal } from '../../shared/components/layouts/OldModal';

import ContactManagerContainer from "./Container";

class ContactContainerModal extends Component{
  render() {
    return <ContactManagerContainer {...this.props}/>        
  }
}

ContactContainerModal =
  asModal(ContactContainerModal);

export default ContactContainerModal;



// WEBPACK FOOTER //
// ./src/features/contacts/components/ContactContainerModal.js